import { UniqueIdentifier } from "@dnd-kit/core";
import { EditorFilter } from "../types";

// // // //

/**
 * findEditorFilterByID
 * Finds an EditorFilter recursively by its ID.
 * @function findEditorFilterByID
 * @param {EditorFilter} filter - The Editor Filter to search within.
 * @param {UniqueIdentifier} id - The ID of the filter to find.
 * @returns {EditorFilter | null} - The matching Editor Filter, or null if no match is found.
 */
export function findEditorFilterByID(
    filter: EditorFilter,
    id: UniqueIdentifier,
): EditorFilter | null {
    if (filter.id === id) {
        return filter;
    }

    for (const nestedFilter of filter.nested) {
        const foundFilter = findEditorFilterByID(nestedFilter, id);
        if (foundFilter) {
            return foundFilter;
        }
    }

    return null;
}
